
import { RefCodeMetadataBase } from './ref-code.metadata.base';


export class RefCodeMetadata extends RefCodeMetadataBase {
  constructor() {
    super();
  }
}

export const REF_CODE_METADATA: RefCodeMetadata = new RefCodeMetadata();


